import * as Actions from 'app/store/actions/fuse';

const initialState = {
	state: false,
	options: {
		children: ' '
	}
};

const dialog = function (state = initialState, action) {
	switch (action.type) {
		case Actions.OPEN_DIALOG: {
			return {
				...state,
				state: true,
				// Reset to initial options, then apply new options
				// This prevents PaperProps/style bleeding between dialogs
				options: {
					...initialState.options,
					...action.options
				}
			};
		}
		case Actions.CLOSE_DIALOG: {
			return {
				...state,
				state: false,
				// Reset options to initial state on close
				options: initialState.options
			};
		}
		default:
			return state;
	}
};

export default dialog;
